import { render, staticRenderFns } from "./ConfirmSaveInternalMovement.vue?vue&type=template&id=b63af6f4&scoped=true"
import script from "./ConfirmSaveInternalMovement.vue?vue&type=script&lang=js"
export * from "./ConfirmSaveInternalMovement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63af6f4",
  null
  
)

export default component.exports